import pseudoTranslate from '@nike/i18n-pseudo';
import localeMap from '../utils/locale-map';

export default function relativeTimeFormat(locale, value, unit, options = {}) {
  // Removing any options that were given a null value.
  // This mostly comes from the React component.
  const finalOpts = Object.keys(options).reduce((accumulator, currKey) => {
    const currValue = options[currKey];
    if (currValue !== null) {
      accumulator[currKey] = currValue;
    }
    return accumulator;
  }, {});

  let finalLocale = locale;

  // Map this locale if necessary
  if (Object.keys(localeMap).includes(locale)) {
    finalLocale = localeMap[locale];
  }

  let relativeOutput = new Intl.RelativeTimeFormat(finalLocale, finalOpts).format(value, unit);

  if (locale === 'pseudo') {
    relativeOutput = pseudoTranslate(relativeOutput);
  }

  return relativeOutput;
}
